import React, { useEffect, useState } from "react";
import Card from "src/components/Cards/Basic";
import axios from "src/config/axios";
import GateLogTable from "../../../../../components/GateLogTable";

const BookingGateLogSection = ({ stay }) => {
  const [gateLogs, setGateLogs] = useState();

  function getGateLogs() {
    axios
      .get(`/api/v1/gate_logs.json`, { params: { stay_id: stay.id } })
      .then(function (response) {
        setGateLogs(response.data);
      })
      .catch(function (error) {
        console.error(error);
      });
  }

  useEffect(() => {
    getGateLogs();
  }, [stay]);

  return (
    <>
      <Card title={`Schranken Log (${gateLogs?.pagination?.count ?? 0})`}>
        <div>
          <GateLogTable gateLogs={gateLogs} />
        </div>
      </Card>
    </>
  );
};
export default BookingGateLogSection;
